import { Link } from "react-router-dom";

export const homepageFaqData = [
  { question: "What is the difference between Venetian plaster, limewash and microcement?", answer: "Venetian plaster is trowelled in layers for depth and sheen. Limewash is a brushed mineral coating with soft, matte color variation. Microcement is a continuous cementitious finish; wet areas require an appropriately specified system." },
  { question: "Can you apply a finish over my existing walls or fireplace?", answer: "Often, but suitability depends on the existing surface and chosen material. We assess adhesion, repairs, reinforcement and priming before defining the preparation in your written scope." },
  { question: "Can I see samples before choosing?", answer: "Visit our Wayne finish studio by appointment. For installation projects, color, texture and sheen are confirmed through the agreed sample process. Retail custom sample boards are purchased separately." },
  { question: "What determines the price?", answer: "Surface area, existing conditions, access, preparation, finish system and the desired texture affect the scope and price. We provide a written proposal for your project." },
  { question: "Do you work with designers and builders?", answer: "Yes. We work with homeowners, designers, builders and business owners on residential, new construction and commercial spaces." },
  { question: "Where in North Jersey do you work?", answer: "Based in Wayne, we serve Bergen, Passaic, Morris, Essex and Hudson counties. Share your project town when you contact us." },
];

const HomepageFAQ = () => (
  <section id="faq" className="py-16 md:py-24 bg-muted" aria-labelledby="faq-heading">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <p className="text-[11px] uppercase tracking-[0.28em] text-clay mb-4">Common Questions</p>
      <h2 id="faq-heading" className="font-heading text-3xl md:text-4xl text-foreground leading-tight">
        Specialty Finish FAQs
      </h2>
      <div className="mt-10 divide-y divide-border border-y border-border">
        {homepageFaqData.map((faq) => (
          <div key={faq.question} className="py-6">
            <h3 className="font-heading text-lg text-foreground">{faq.question}</h3>
            <p className="mt-2 text-muted-foreground leading-relaxed">{faq.answer}</p>
          </div>
        ))}
      </div>
      <p className="mt-8 text-sm text-muted-foreground">
        Looking for details on a specific service? See our{" "}
        <Link to="/services/venetian-plaster/" className="underline underline-offset-4 hover:text-clay">Venetian plaster</Link>,{" "}
        <Link to="/services/limewash-painting/" className="underline underline-offset-4 hover:text-clay">limewash</Link> and{" "}
        <Link to="/plaster-showers-nj/" className="underline underline-offset-4 hover:text-clay">microcement</Link> pages.
      </p>
    </div>
  </section>
);

export default HomepageFAQ;
